/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
const components = {};

export function registerComponent(name, Component) {
  components[name] = Component;
}

export default function BASENavItem(props) {
  const C = components[props.type];
  return C ? <C {...props} /> : null;
}
